import React, { useEffect, useState } from 'react';

import { Container, Button, ButtonText } from './styles';

interface InvoiceDetailButtonsInterface {
  callback: (index: number) => void;
}

const InvoiceDetailButtonsComponent: React.FC<InvoiceDetailButtonsInterface> = ({
  callback
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    callback(activeIndex);
  }, [activeIndex]);

  return (
    <Container>
      <Button
        index={0}
        active={activeIndex === 0}
        onPress={() => setActiveIndex(0)}
      >
        <ButtonText active={activeIndex === 0}>Fatura atual</ButtonText>
      </Button>
      <Button
        index={1}
        active={activeIndex === 1}
        onPress={() => setActiveIndex(1)}
      >
        <ButtonText active={activeIndex === 1}>Próxima fatura</ButtonText>
      </Button>
    </Container>
  );
};

export default InvoiceDetailButtonsComponent;
